// extracted by mini-css-extract-plugin
export default {"suspense":"Suspense_suspense__WGdY5"};